<template>

    <div class="container">
        <div class="row">
            <div class="col-12">
                <h1>{{ heading }}</h1>
                <p>{{ description }}</p>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props: [
            'heading',
            'description',
        ],
    }
</script>
